import { default as axios } from "@/use/utilities/axios/up/axios-instance-primo-up";

/**
 * Fetch media data for a prescription test
 * @param {string|number} prescriptionTestId - The ID of the prescription test
 * @returns {Promise<Object>} The prescription test data with media
 * @throws {Error} When the request fails or prescriptionTestId is invalid
 */
export async function fetchMedia(prescriptionTestId) {
  let prescriptionTest;

  await axios
    .get(`/prescription-tests/${prescriptionTestId}/media`)
    .then(async (response) => {
      prescriptionTest = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionTest };
}
